import React from "react";

const LoadingSpinner = ({ message = "Chargement..." }) => {
  return (
    <div className="flex h-64 items-center justify-center">
      <div className="relative h-16 w-16">
        <div className="absolute left-0 top-0 h-16 w-16 rounded-full border-4 border-[#57A863] border-opacity-20"></div>
        <div className="border-transparent absolute left-0 top-0 h-16 w-16 animate-spin rounded-full border-4 border-t-[#57A863]"></div>
      </div>
      <p className="ml-4 text-gray-600">{message}</p>
    </div>
  );
};

export default LoadingSpinner;
